import { useState } from 'react'
import { toast } from 'react-toastify'

interface Location {
  latitude: number
  longitude: number
}

const useLocation = () => {
  const [location, setLocation] = useState<Location>()
  const [requestingLocation, setRequestingLocation] = useState(false)

  const requestLocation = () => {
    setRequestingLocation(true)
    navigator.geolocation.getCurrentPosition(position => {
      setLocation({
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
      })
      setRequestingLocation(false)
    }, error => {
      toast.error('Houve um erro ao obter sua localização')
      setRequestingLocation(false)
    })
  }

  return {
    location,
    requestingLocation,
    requestLocation,
  }
}

export default useLocation
